import { html } from 'lit';
import { query, customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_DEVICE_SCAN_FORM } from '../../../../../../../../../webcomponents.constants';
import { FormGroup } from '../../../../../../../../../ui/gzForm/formGroup/form-group';
import { GzPolicyFullPageWindowFormWebComponent } from '../../../../../../../../common/policyPanel/uiSettings/dialogs/fullPage/form';
import {
  AntimalwareOnDemandDeviceScanSettings,
  AntimalwareOnDemandScanTaskScanType,
} from '@nirvana/shared/dtos/types/policies/common';
import _ from 'lodash';
import { getAntimalwareOnDemandScanTaskDefaultValue } from '../../../../../../utils/uiSettings/antimalware/antimalware.values';
import { GzAntimalwareOnDemandScanTaskOptionsFormWebComponent } from '../../optionsForm';

@customElement(WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_DEVICE_SCAN_FORM)
export class GzAntimalwareOnDemandDeviceScanFormWebComponent extends GzPolicyFullPageWindowFormWebComponent<AntimalwareOnDemandDeviceScanSettings> {
  // options section
  @query('gz-policy-panel-antimalware-on-demand-scan-task-options-form')
  private optionsForm: GzAntimalwareOnDemandScanTaskOptionsFormWebComponent;

  public constructor(
    private scanType: AntimalwareOnDemandScanTaskScanType,
    value?: AntimalwareOnDemandDeviceScanSettings
  ) {
    super(value);
  }

  public resetValue() {
    this.value = undefined;
    this.setFormGroupValue();
  }

  protected getConvertedFormValue() {
    const formValue = _.cloneDeep(this.formGroup.value);
    return _.get(formValue, ['optionsForm'], {});
  }

  async createFormGroup() {
    this.formGroup = FormGroup.build({});

    await this.optionsForm.updateComplete;
    this.formGroup.addFormChild(['optionsForm'], this.optionsForm.formGroup);
  }

  protected async setFormGroupValue() {
    let valueToBeSet;
    if (!this.value) {
      valueToBeSet = getAntimalwareOnDemandScanTaskDefaultValue(this.scanType) as any;
    } else {
      valueToBeSet = this.value;
    }

    this.optionsForm.setFormGroupValue(this.scanType, {
      scanProfile: valueToBeSet.scanProfile,
      scanSettings: {
        fileTypes: valueToBeSet.scanSettings.fileTypes,
        extensions: valueToBeSet.scanSettings.extensions,
        archives: valueToBeSet.scanSettings.archives,
        miscellaneous: valueToBeSet.scanSettings.miscellaneous,
        action: valueToBeSet.scanSettings.action,
      },
    });

    this.formGroup.value = valueToBeSet;
  }

  /**
   * Render specific content.
   */
  protected renderContent() {
    return html`
      <div class="tasks-form-container">
        <!-- Options section -->
        <div id="tasks-options-section">
          <gz-policy-panel-antimalware-on-demand-scan-task-options-form>
          </gz-policy-panel-antimalware-on-demand-scan-task-options-form>
        </div>
      </div>
    `;
  }
}
